module.exports = __webpack_public_path__ + "img/logo-white.a1697acf.svg";